import React from 'react';
import { enums } from '~/util';
import { ServicesContext, useAdminService } from '~/services';
import { Spinner } from 'react-bootstrap';
import { ExternalAccountInfo } from './ExternalAccountInfo';

export type ExternalAccountNameType = 'LeadingReach' | 'One Healthcare ID';
interface UserIntegrationsProps {
    user: UserType;
    setServerError: (e: { message: string }) => void;
    editable: boolean;
}
export function UserIntegrations({ user, setServerError, editable }: UserIntegrationsProps) {
    const services = React.useContext(ServicesContext);
    const { removeExternalAccount } = useAdminService();
    const [unlinkAccount, setUnlinkAccount] = React.useState<ExternalAccountNameType | null>(null);
    const [loading, setLoading] = React.useState(false);
    const coreAppAccount = user?.user_external_accounts?.find(
        (x) => enums(['user', 'external_account_types', x.type]) === 'Core App'
    );
    const ohidAccount = user?.user_external_accounts?.find(
        (x) => enums(['user', 'external_account_types', x.type]) === 'One Healthcare ID'
    );
    const accountMap = {
        LeadingReach: coreAppAccount,
        'One Healthcare ID': ohidAccount,
    };

    async function unlinkUser() {
        try {
            if (unlinkAccount) {
                setLoading(true);
                await removeExternalAccount(user, accountMap[unlinkAccount]?.id);
                setLoading(false);
                setUnlinkAccount(null);
            }
        } catch (e) {
            setLoading(false);
            setUnlinkAccount(null);
            setServerError(e);
        }
    }

    return (
        <div className="card mb-2">
            <div className="card-header">Integrations</div>
            <div className="card-body">
                <ExternalAccountInfo
                    accountName="LeadingReach"
                    externalAccount={coreAppAccount}
                    editable={editable}
                    loading={loading}
                    setUnlinkAccount={setUnlinkAccount}
                />
                {services.user.hasFeatureToggle('one_healthcare_id') && (
                    <ExternalAccountInfo
                        accountName="One Healthcare ID"
                        externalAccount={ohidAccount}
                        editable={editable}
                        loading={loading}
                        setUnlinkAccount={setUnlinkAccount}
                    />
                )}
                {unlinkAccount && (
                    <div className="text-center mt-3">
                        <p>
                            Are you sure you want to unlink this user&apos;s {unlinkAccount}{' '}
                            account?
                        </p>
                        <div>
                            <button
                                className="btn btn-secondary me-3"
                                onClick={() => setUnlinkAccount(null)}
                                type="button"
                            >
                                Cancel
                            </button>
                            <button
                                className="btn btn-danger"
                                disabled={loading}
                                onClick={unlinkUser}
                                type="button"
                            >
                                {loading && (
                                    <Spinner
                                        animation="border"
                                        variant="light"
                                        size="sm"
                                        role="status"
                                        className="me-1"
                                    />
                                )}
                                Yes, Reset
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
